function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "m4gna"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.716 36.986C.716 16.873 17.021.568 37.134.568s36.418 16.305 36.418 36.418-16.305 36.417-36.418 36.417S.716 57.1.716 36.986z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.716 36.986C.716 16.873 17.021.568 37.134.568s36.418 16.305 36.418 36.418-16.305 36.417-36.418 36.417S.716 57.1.716 36.986z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#5575fa",
  strokeMiterlimit: 20,
  strokeWidth: 6,
  d: "M.716 36.986C.716 16.873 17.021.568 37.134.568s36.418 16.305 36.418 36.418-16.305 36.417-36.418 36.417S.716 57.1.716 36.986z",
  clipPath: "url('#m4gna')"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#5575fa",
  strokeMiterlimit: 20,
  strokeWidth: 2,
  d: "M24.473 26.894v3.446c0 .42.344.765.765.765h2.297v0l1.149 1.915v0l.919-1.915v0h2.526a.768.768 0 0 0 .766-.765v-3.446a.768.768 0 0 0-.766-.765h-6.89a.768.768 0 0 0-.766.765z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#5575fa",
  strokeMiterlimit: 20,
  strokeWidth: 2,
  d: "M35.958 19.62v8.04c0 .421.344.766.765.766h6.891v0l1.149 2.68v0l1.531-2.68v0h3.828a.768.768 0 0 0 .766-.766v-8.04a.768.768 0 0 0-.766-.765H36.723a.768.768 0 0 0-.765.766z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#5575fa",
  strokeMiterlimit: 20,
  strokeWidth: 2,
  d: "M39.02 21.918h8.422"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#5575fa",
  strokeMiterlimit: 20,
  strokeWidth: 2,
  d: "M39.02 24.98h5.36"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#5474fa",
  d: "M39.838 43.77c0 1.62-1.35 2.97-2.97 2.97-1.675 0-3.025-1.35-3.025-2.97a3.02 3.02 0 0 1 3.025-3.025c1.62 0 2.97 1.35 2.97 3.025zm-2.97-4.645a4.61 4.61 0 0 0-4.645 4.645c0 1.62.864 3.078 2.16 3.888a8.89 8.89 0 0 0-6.318 7.453c-.108.972 1.512 1.026 1.62.162a7.199 7.199 0 0 1 7.183-6.373c3.672 0 6.696 2.755 7.128 6.373.108.864 1.729.81 1.62-.162-.378-3.564-2.916-6.48-6.264-7.453a4.686 4.686 0 0 0 2.106-3.888c0-2.593-2.052-4.645-4.59-4.645z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#5575fa",
  strokeMiterlimit: 20,
  strokeWidth: 0.5,
  d: "M39.838 43.77c0 1.62-1.35 2.97-2.97 2.97-1.675 0-3.025-1.35-3.025-2.97a3.02 3.02 0 0 1 3.025-3.025c1.62 0 2.97 1.35 2.97 3.025zm-2.97-4.645a4.61 4.61 0 0 0-4.645 4.645c0 1.62.864 3.078 2.16 3.888a8.89 8.89 0 0 0-6.318 7.453c-.108.972 1.512 1.026 1.62.162a7.199 7.199 0 0 1 7.183-6.373c3.672 0 6.696 2.755 7.128 6.373.108.864 1.729.81 1.62-.162-.378-3.564-2.916-6.48-6.264-7.453a4.686 4.686 0 0 0 2.106-3.888c0-2.593-2.052-4.645-4.59-4.645z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#5474fa",
  d: "M24.77 38.5a2.39 2.39 0 0 1-2.37 2.369c-1.335 0-2.411-1.077-2.411-2.369A2.408 2.408 0 0 1 22.4 36.09c1.292 0 2.368 1.076 2.368 2.411zm-2.37-3.703a3.676 3.676 0 0 0-3.703 3.703c0 1.292.689 2.455 1.722 3.101a7.088 7.088 0 0 0-5.038 5.943c-.086.775 1.206.818 1.292.13a5.74 5.74 0 0 1 5.728-5.082c2.928 0 5.34 2.196 5.684 5.081.086.69 1.378.646 1.292-.129-.301-2.842-2.325-5.168-4.995-5.943a3.737 3.737 0 0 0 1.68-3.1c0-2.068-1.637-3.704-3.661-3.704z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#5575fa",
  strokeMiterlimit: 20,
  strokeWidth: 0.8,
  d: "M24.77 38.5a2.39 2.39 0 0 1-2.37 2.369c-1.335 0-2.411-1.077-2.411-2.369A2.408 2.408 0 0 1 22.4 36.09c1.292 0 2.368 1.076 2.368 2.411zm-2.37-3.703a3.676 3.676 0 0 0-3.703 3.703c0 1.292.689 2.455 1.722 3.101a7.088 7.088 0 0 0-5.038 5.943c-.086.775 1.206.818 1.292.13a5.74 5.74 0 0 1 5.728-5.082c2.928 0 5.34 2.196 5.684 5.081.086.69 1.378.646 1.292-.129-.301-2.842-2.325-5.168-4.995-5.943a3.737 3.737 0 0 0 1.68-3.1c0-2.068-1.637-3.704-3.661-3.704z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#5474fa",
  d: "M53.692 38.5a2.39 2.39 0 0 1-2.369 2.369c-1.335 0-2.411-1.077-2.411-2.369a2.408 2.408 0 0 1 2.411-2.411c1.292 0 2.37 1.076 2.37 2.411zm-2.369-3.703A3.676 3.676 0 0 0 47.62 38.5c0 1.292.689 2.455 1.722 3.101a7.088 7.088 0 0 0-5.038 5.943c-.086.775 1.205.818 1.292.13a5.74 5.74 0 0 1 5.727-5.082c2.929 0 5.34 2.196 5.685 5.081.086.69 1.378.646 1.292-.129-.301-2.842-2.325-5.168-4.996-5.943a3.737 3.737 0 0 0 1.68-3.1c0-2.068-1.636-3.704-3.66-3.704z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#5575fa",
  strokeMiterlimit: 20,
  strokeWidth: 0.8,
  d: "M53.692 38.5a2.39 2.39 0 0 1-2.369 2.369c-1.335 0-2.411-1.077-2.411-2.369a2.408 2.408 0 0 1 2.411-2.411c1.292 0 2.37 1.076 2.37 2.411zm-2.369-3.703A3.676 3.676 0 0 0 47.62 38.5c0 1.292.689 2.455 1.722 3.101a7.088 7.088 0 0 0-5.038 5.943c-.086.775 1.205.818 1.292.13a5.74 5.74 0 0 1 5.727-5.082c2.929 0 5.34 2.196 5.685 5.081.086.69 1.378.646 1.292-.129-.301-2.842-2.325-5.168-4.996-5.943a3.737 3.737 0 0 0 1.68-3.1c0-2.068-1.636-3.704-3.66-3.704z"
})));

var SvgWelcomeStep2 = function SvgWelcomeStep2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWelcomeStep2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/welcome-step-2.0a187ae6.svg";
export { ForwardRef as ReactComponent };